import { VideoDetail } from '@fs/zion-rootstech'

const VideoModule = `
  ${VideoDetail}
  fragment VideoModule on VideoModule {
    description
    title
    video {
      ...VideoDetail
    }
  }
`

export default VideoModule
